<template>
  <div>
    <!-- ✅ Si NON connecté : on affiche un simple bouton "Se connecter" -->
    <button
      v-if="!isLoggedIn"
      class="btn btn-order2"
      type="button"
      @click.stop="goToLogin"
    >
      <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
      <span class="hide-in-small-devices">Se connecter</span>
    </button>

    <!-- ✅ Si connecté : on affiche le dropdown complet -->
    <div v-else class="dropdown" @click.stop="toggleDropdown">
      <button
        class="btn btn-order2 dropdown-toggle"
        type="button"
        id="userDropdown"
        aria-haspopup="true"
        :aria-expanded="isDropdownVisible ? 'true' : 'false'"
      >
        <font-awesome-icon :icon="['fas', 'user']" />
        <span class="hide-in-small-devices">Mon Espace Personnel</span>
      </button>

      <div
        class="dropdown-menu"
        :class="{ show: isDropdownVisible }"
        aria-labelledby="userDropdown"
      >
        <a class="dropdown-item" @click.stop="navigateTo('my-menus')">
          <font-awesome-icon class="icon" icon="fa-solid fa-utensils" />
          Mes Meilleurs Menus
        </a>
        <a class="dropdown-item" @click.stop="navigateTo('my-shopping-list')">
          <font-awesome-icon class="icon" :icon="['fas', 'shopping-basket']" />
          Mes courses
        </a>
        <a class="dropdown-item" @click.stop="navigateTo('apports')">
          <font-awesome-icon class="icon" :icon="['fas', 'apple-alt']" />
          Mes apports
        </a>
        <a class="dropdown-item" @click.stop="navigateTo('my-preferences')">
          <font-awesome-icon class="icon" :icon="['fas', 'cogs']" />
          Mes préférences
        </a>
        <a class="dropdown-item" @click.stop="navigateTo('deconnection')">
          <font-awesome-icon class="icon" :icon="['fas', 'right-from-bracket']" />
          Se déconnecter
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router/composables";
import { ref, onMounted, onBeforeUnmount } from "vue";
import { userState } from "@/utils/store";

export default {
  setup() {
    const isDropdownVisible = ref(false);
    const isLoggedIn = ref(false);
    const router = useRouter();

    const refreshAuthState = () => {
      let storeLogged = false;
      try {
        if (userState && typeof userState.isLoggedIn === "function") {
          storeLogged = !!userState.isLoggedIn();
        }
      } catch (e) {
        storeLogged = false;
      }

      const access = localStorage.getItem("accessToken");
      const refresh = localStorage.getItem("refreshToken");
      const tokenLogged = !!(access || refresh);

      isLoggedIn.value = storeLogged || tokenLogged;

      // Si on devient "déconnecté", on ferme le dropdown
      if (!isLoggedIn.value) {
        isDropdownVisible.value = false;
      }
    };

    const toggleDropdown = () => {
      isDropdownVisible.value = !isDropdownVisible.value;
      refreshAuthState();
    };

    const closeDropdown = (event) => {
      if (isDropdownVisible.value && !event.target.closest(".dropdown")) {
        isDropdownVisible.value = false;
      }
    };

    const navigateTo = (routeName) => {
      isDropdownVisible.value = false;
      router.push({ name: routeName });
    };

    const goToLogin = () => {
      router.push({ name: "connection" });
    };

    const onFocus = () => refreshAuthState();
    const onVisibilityChange = () => {
      if (!document.hidden) refreshAuthState();
    };

    onMounted(() => {
      refreshAuthState();

      document.addEventListener("click", closeDropdown);
      window.addEventListener("storage", refreshAuthState);
      window.addEventListener("focus", onFocus);
      document.addEventListener("visibilitychange", onVisibilityChange);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", closeDropdown);
      window.removeEventListener("storage", refreshAuthState);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    });

    return {
      userState,
      isDropdownVisible,
      isLoggedIn,
      toggleDropdown,
      navigateTo,
      goToLogin,
    };
  },
};
</script>

<style scoped>
.btn-order {
  color: white;
  background-color: #004c40;
  transition: 0.3s;
  font-family: "TangoSans";
}

.btn-order:hover {
  color: #004c40;
  background-color: white;
  border-color: #004c40;
}

.btn-order2 {
  color: white;
  background-color: rgb(133, 187, 47);
  transition: 0.3s;
  font-family: "TangoSans";
}

.btn-order2:hover {
  color: white;
  background-color: #004c40;
  border-color: #004c40;
}

.dropdown-menu {
  width: 233px;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-item:hover {
  color: white;
  background-color: #004c40;
}

.dropdown-item .icon {
  width: 35px;
}

/* Responsive HEADER */
@media (max-width: 992px) {
  .btn-order2 {
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .hide-in-small-devices {
    display: none;
  }

  .dropdown-menu {
    left: -180px;
  }
}
</style>
